module.exports = __webpack_public_path__ + "img/btn_shadow.2a7baef9.png";